import Table from './BaseTable';
import withData from './hoc/withData';
import withInlineEdit from './hoc/withInlineEdit';
import withMultiDnd from './hoc/withMultiDnD';
export * from './components';
export * from './utils';

// smart Data table
const DataTable = withData(Table);

// Table with inline edit
const InlineEditTable = withInlineEdit(Table);

// Smart table with inline edit
const InlineEditDataTable = withData(InlineEditTable);
const VerticalList = withMultiDnd(Table);
export { Table,
// Base Table
DataTable, InlineEditTable, InlineEditDataTable, withData, withInlineEdit, VerticalList };